import { defineNuxtRouteMiddleware, useRequestEvent } from '#imports'

import { updateActiveSpan } from '@backmarket/instrument/updateActiveSpan'
import { useI18nLocale } from '@backmarket/nuxt-module-i18n/useI18nLocale'
import { faro } from '@grafana/faro-web-sdk'

/**
 * Per-route hook that updates downstream observability tooling with the
 * matched route name and metadata.
 */
export default defineNuxtRouteMiddleware((to) => {
  if (process.server) {
    const event = useRequestEvent()
    if (!event) return

    updateActiveSpan((span) => {
      // We can use `Array#at` here because this code runs on the server.
      const route = to.matched.at(-1) ?? to
      const path = route.path.replace(/\([a-zA-Z|-]+\)/g, '')
      const resource = `${event.node.req.method} ${path}`

      span.setAttributes({
        // dd legacy
        'resource.name': resource,
        'resource.locale': to.params?.locale ?? 'unknown',
        // otel
        'http.route': path,
      })
    })

    return
  }

  if (process.client && faro?.api) {
    if (to.name) {
      faro.api.setView({ name: String(to.name) })
    }

    faro.api.setUser({ attributes: { locale: useI18nLocale() } })
  }
})
